import { graphql } from '@/generated/gql';

export const SUPPLIER_RISK_SCORE_WIDGET_QUERY = graphql(/* GraphQL */ `
  query SupplierRiskScoreWidget($id: UUID!) {
    cataclysm {
      supplier(id: $id) {
        id
        score
        categories {
          id
          score
        }
      }
    }
  }
`);
